import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { showHttpErrorToast } from '@common/utils/http/show-http-error-toast';



const endpoint = (id: number) => `market-rates/${id}/download-md`;

interface Response extends BackendResponse {}

interface Payload {
  id: number;
  investor_code: string;
  sheet_name: string;
}

export function useDownloadMdRateSheet() {
  return useMutation({
    mutationFn: (payload: Payload) => fetchMdRateSheet(payload),
    onError: err => showHttpErrorToast(err),
  });
}

function fetchMdRateSheet({id, investor_code, sheet_name}: Payload): Promise<Response> {
  return apiClient.post(endpoint(id), {investor_code: investor_code, sheet_name: sheet_name}, {responseType: 'blob'}).then(r => r.data);
}
